<template>
  <div ref='modal' aria-hidden="true" class="modal fade hidden always-on-top" role="dialog" tabindex='-1'>
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <slot name='header'></slot>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <img src="../assets/hurray.svg">
          <h1>{{ $t('onboarding.hurra')}}, {{currentUser.full_name}}</h1>
          <p>{{ $t('onboarding.success')}}</p>
          <p>{{ $t('onboarding.questions')}}
            <a target="false" :href='helpCenterUrl'>{{ $t('header.help_center')}}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    created() {
      this.showModal()
    },
    watch: {
      currentUser() {
        this.showModal()
      }
    },
    computed: {
      helpCenterUrl() {
        return this.locale === 'de' ? 'https://support.relatico.com/de/' : 'https://support.relatico.com/en/'
      },
    },
    methods: {
      compareObj() {
      },
      showModal() {
        if (this.currentUser.has_files && this.currentUser.has_checklist && this.currentUser.has_folders && !this.currentUser.modal_seen) {
          $(this.$refs.modal).modal('show')
          this.store.updateUser(this.currentUser, { user: { modal_seen: true } })
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  .modal-content
    background: #fff
    text-align: center
    p
      line-height: 24px
      font-size: 16px
    h1
      text-align: center
  .modal-header
    border: none
    padding-bottom: 0
</style>
